import { useState, useEffect } from "react";
import { getPackages, createCheckout, apiError } from "@/lib/api";
import { naira, creditsToTime } from "@/components/PricingSection";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import { logWarn } from "@/lib/log";

const TopUpCard = ({ p, busy, onBuy }) => (
    <div
        className={`border bg-obsidian p-5 flex flex-col ${
            p.id === "pro" ? "border-blaze/60" : "border-white/10"
        }`}
        data-testid={`topup-card-${p.id}`}
    >
        <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/50">{p.name}</div>
        <div className="font-display font-bold text-2xl mt-2">{naira(p.price_ngn)}</div>
        <div className="font-mono text-xs text-white/60 mt-2 flex-1">
            {p.credits.toLocaleString()} credits · ≈ {creditsToTime(p.credits)}
        </div>
        <button
            onClick={() => onBuy(p)}
            disabled={busy !== null}
            className="mt-4 w-full bg-blaze hover:bg-blazeHover disabled:opacity-40 text-white font-mono uppercase text-[11px] tracking-[0.2em] py-2.5 flex items-center justify-center gap-2 transition-colors"
            data-testid={`topup-button-${p.id}`}
        >
            {busy === p.id ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : null}
            {busy === p.id ? "Redirecting..." : `Pay ${naira(p.price_ngn)}`}
        </button>
    </div>
);

export const TopUpPackages = () => {
    const [packages, setPackages] = useState([]);
    const [busy, setBusy] = useState(null);

    useEffect(() => {
        getPackages().then(setPackages).catch((e) => logWarn("packages load failed", e));
    }, []);

    const buy = async (p) => {
        setBusy(p.id);
        try {
            const res = await createCheckout(p.id);
            window.location.href = res.payment_link;
        } catch (e) {
            toast.error(apiError(e));
            setBusy(null);
        }
    };

    return (
        <div data-testid="topup-packages">
            <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/40 mb-4 flex items-center gap-2">
                <Lock className="w-3 h-3" />
                Secure payment via Flutterwave — card, bank transfer or USSD
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
                {packages.map((p) => (
                    <TopUpCard key={p.id} p={p} busy={busy} onBuy={buy} />
                ))}
            </div>
        </div>
    );
};
